export let CalendarGridCurrentTimeIndicatorCssVars = /*#__PURE__*/function (CalendarGridCurrentTimeIndicatorCssVars) {
  CalendarGridCurrentTimeIndicatorCssVars["yPosition"] = "--y-position";
  return CalendarGridCurrentTimeIndicatorCssVars;
}({});